module.exports = __webpack_public_path__ + "img/1920_nav_img4.1a868293.png";